goog.module('yext.location.Location');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

/**
 * Location field.
 * Note: This is intentionally named Location instead of LocationField because
 * yext.location.LocationField is actively used in existing old EE code.
 *
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 * @author Eric Hong (ehong@yext.com)
 */
const Location = function($ctx) {
  this.$ctx = $ctx;
  this.$input = this.$ctx.find('.js-location-field-edit-input');
  this.$key = this.$ctx.find('.js-location-field-edit-key');
  this.$entityReferencesInput = this.$ctx.find('.js-location-field-edit-entity-references');
  this.indeterminate = false;
  this.fieldName = this.$ctx.find('input[name="field"]').val();
  this.storeValue();
  this.bind();

  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * Broadcast messages with the field as context
 */
Location.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the field to a stored state.
 */
Location.prototype.reset = function() {
  this.set({
    value: this.storedValue.value,
    indeterminate: this.storedValue.indeterminate,
  });
  // This will force the edit component to reset its state, which is necessary for LocationEdit
  // because it has additional state that should be reset on "cancel".
  this.$key.val((_, val) => val === '0' ? '1' : '0').trigger('change');
};

/**
 * Set the fields value
 *
 * @param {!Object} field Field data
 */
Location.prototype.set = function(field) {
  this.$input.val(field.value).trigger('change');
  this.indeterminate = !!field.indeterminate;
};

/**
 * Store the state for use in reset
 *
 * @param {!jQuery} $display The parent display element
 */
Location.prototype.storeValue = function($display) {
  this.storedValue = {
    value: this.$input.val(),
    entityReferences: this.$entityReferencesInput.val(),
    indeterminate: this.indeterminate,
  };
  if ($display !== undefined) {
    // NOTE: The entity reference input change must be triggered before the value input, otherwise
    //       displaying the new entity reference will error since the display depends on the entity
    //       reference info.
    let entityReferencesInput = $display.find('.js-location-field-display-entity-references')[0];
    $(entityReferencesInput).val(this.storedValue.entityReferences).trigger('change');
    let input = $display.find('.js-location-field-display-input')[0];
    $(input).val(this.storedValue.value).trigger('change');
  }
};

/**
 * Binds the update events.
 */
Location.prototype.bind = function() {
  var self = this;
  this.$input.inputchange(() => {
    self.message('updated');
  });
};

exports = Location;
